<form [formGroup]="schedulesForm">
  <div class="grid">
    <div class="col-3 mb-5">
      <p-dropdown
        id="preset"
        optionLabel="name"
        optionValue="id"
        [options]="presets"
        formControlName="preset"
        [style]="{ width: '100%' }"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        placeholder="{{ 'schedules.form.preset' | translate }}"
      ></p-dropdown>
    </div>

    <div class="col-2 mb-5">
      <p-dropdown
        id="timezone"
        optionLabel="name"
        optionValue="id"
        [options]="generateTimeZones()"
        formControlName="timeZone"
        [style]="{ width: '100%' }"
        placeholder="{{ 'schedules.form.timezone' | translate }}"
      ></p-dropdown>
    </div>

    <div class="col-2 mb-5 flex">
      <input
        id="cron"
        class="w-full"
        pInputText
        formControlName="cron"
        placeholder="{{ 'schedules.form.cron' | translate }}"
      />
      <i class="edit-cron-button pi pi-pen-to-square" (click)="toggleEditCronDialog()"></i>
    </div>

    <div class="col-5 mb-5 align-items-left">
      <div class="flex align-items-center mb-2">
        <p-toggleButton
          class="mr-2"
          formControlName="enabled"
          inputId="enableSchedule"
          [onLabel]="'schedules.form.enabled.on' | translate"
          [offLabel]="'schedules.form.enabled.off' | translate"
          pTooltip="{{ 'schedules.form.tooltip.enabled' | translate }}"
          tooltipPosition="top"
        ></p-toggleButton>
        <label class="block ml-2" for="enableSchedule">
          {{ 'schedules.form.enabled.label' | translate }}
        </label>
      </div>
      <div class="flex align-items-left mb-2">
        <p-checkbox
          class="mr-2"
          formControlName="runClone"
          [binary]="true"
          inputId="runCloneWorkflow"
          pTooltip="{{ 'schedules.form.tooltip.runClone' | translate }}"
          tooltipPosition="top"
        />
        <label class="block" for="runCloneWorkflow">
          {{ 'schedules.form.runClone' | translate }}
        </label>
      </div>
      <div class="flex align-items-left mb-2">
        <p-checkbox
          class="mr-2"
          formControlName="stopSessionBeforeRun"
          [binary]="true"
          inputId="stopSessionBeforeRunWorkflow"
          pTooltip="{{ 'schedules.form.tooltip.stopSessionBeforeRun' | translate }}"
          tooltipPosition="top"
        />
        <label class="block" for="stopSessionBeforeRunWorkflow">
          {{ 'schedules.form.stopSessionBeforeRun' | translate }}
        </label>
      </div>
      <div class="flex align-items-left mb-2">
        <p-checkbox
          class="mr-2"
          formControlName="waitComplete"
          [binary]="true"
          inputId="waitCompleteWorkflow"
          pTooltip="{{ 'schedules.form.tooltip.waitComplete' | translate }}"
          tooltipPosition="top"
        />
        <label class="block" for="waitCompleteWorkflow">
          {{ 'schedules.form.waitComplete' | translate }}
        </label>
      </div>
      <div class="flex align-items-left">
        <p-checkbox
          class="mr-2"
          formControlName="runIfError"
          [binary]="true"
          inputId="runIfErrorWorkflow"
          pTooltip="{{ 'schedules.form.tooltip.runIfError' | translate }}"
          tooltipPosition="top"
        />
        <label class="block" for="runIfErrorWorkflow">
          {{ 'schedules.form.runIfError' | translate }}
        </label>
      </div>
    </div>

    <div *ngIf="showBtn" class="col-2 mb-5 text-right flex align-items-start justify-content-end">
      <div class="flex align-items-center actions">
        <button
          icon="pi pi-ban"
          pButton
          type="button"
          class="p-button-text p-button-link"
          appearance="icon"
          pTooltip="{{ 'msg.workspace.settings.schedules.button.cancel' | translate }}"
          tooltipPosition="top"
          (click)="onCancel()"
        ></button>

        <button
          icon="pi pi-save"
          pButton
          type="button"
          severity="success"
          class="p-button-text p-button-link"
          appearance="icon"
          pTooltip="{{ 'msg.workspace.settings.schedules.button.save' | translate }}"
          tooltipPosition="top"
          (click)="onSubmit()"
        ></button>
      </div>
    </div>

    <p-dialog
      header="{{ 'msg.workspace.settings.schedules.modal.cron-edit.title' | translate }}"
      [modal]="true"
      [(visible)]="cronEditorVisible"
      [style]="{ width: '75rem' }"
    >
      <cron-jobs class="col-10" [config]="cronConfig" [validate]="cronValidate" formControlName="cron"></cron-jobs>

      <p-button
        label="{{ 'msg.workspace.settings.schedules.modal.cron-edit.button.cancel' | translate }}"
        severity="secondary"
        [outlined]="true"
        (click)="toggleEditCronDialog()"
      ></p-button>

      <p-button
        label="{{ 'msg.workspace.settings.schedules.modal.cron-edit.button.apply' | translate }}"
        severity="success"
        (click)="applyCronFromEditor()"
      ></p-button>
    </p-dialog>
  </div>
</form>
